import styled from 'styled-components';

import { mediaConfined, mediaSmallOrTiny } from '@xingternal/layout-tokens';
import { space3XL, spaceXL, spaceXS, spaceXXL, xdlColorText } from '@xingternal/tokens';
import { Meta as MetaComponent } from '@xingternal/typography';
import { Column, Row } from '@xingternal/xing-grid';

export const ColumnContainer = styled(Column)`
  &&& {
    padding-left: ${spaceXS};

    @media ${mediaConfined} {
      padding-left: 0;
    }

    @media (min-width: 1680px) {
      padding-left: 20px;
    }
  }

  button {
    justify-content: flex-start;
    margin-bottom: ${spaceXXL};

    @media ${mediaConfined} {
      margin-bottom: ${space3XL};
    }
  }

  @media ${mediaSmallOrTiny} {
    && button {
      padding-left: ${spaceXS};
    }
  }
`;

export const TextRow = styled(Row)`
  &:last-of-type {
    margin-bottom: 0;
  }

  @media ${mediaSmallOrTiny} {
    && {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

export const Meta = styled(MetaComponent)`
  color: ${xdlColorText};
  columns: 1;
  margin-bottom: ${spaceXL};

  @media ${mediaConfined} {
    && {
      columns: 2;
    }
  }
`;
